import { render, staticRenderFns } from "./details_header.vue.js?vue&type=template&id=3d4e7898!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./details_header.vue?vue&type=template&id=3d4e7898"
import script from "./details_header.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./details_header.vue?vue&type=script&lang=js"
export * from "./details_header.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./details_header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports